import React from 'react';
import styled from 'styled-components';

import { media } from '../../../core';
import Heading from '../Heading';
import Icon from '../Icon';
import Text from '../Text';

export interface NotFoundProps {
  title?: string;
  description?: string;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 32px;

  ${media.tabletPortrait} {
    p {
      text-align: center;
    }
  }
`;

const StyledIcon = styled(Icon)`
  padding-bottom: 40px;
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 8px;

  ${media.tabletPortrait} {
    text-align: center;
  }
`;

const NotFound = ({ title, description }: NotFoundProps) => {
  return (
    <Container>
      <StyledIcon type="no-results" viewSize={220} size={220} />
      <StyledHeading size={6} weight="800">
        {title}
      </StyledHeading>
      <Text noMargin>{description}</Text>
    </Container>
  );
};

NotFound.defaultProps = {
  title: 'No Results Found',
  description: 'Try changing your search or filter to find the results you are looking for.',
};

export default NotFound;
